const normalizeSignalKey = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const missingValues = new Set([
  '',
  'sin dato',
  'n d',
  'nd',
  'n a',
  'na',
  'no especificado',
  'no aplica',
  'por levantar',
]);

export const normalizeMarketTrend = (value = '') => {
  const key = normalizeSignalKey(value);
  if (missingValues.has(key)) return '';

  if (/\b(subieron|subio|sube|aumentaron|aumento|incrementaron|incremento|ha incrementado|alza|mayor|mas alto)\b/.test(key)) {
    return 'Subieron';
  }
  if (/\b(se mantuvieron|se han mantenido|han mantenido|mantuvo|mantienen|mantenido|estable|estables|sin cambio|sin cambios|igual|iguales)\b/.test(key)) {
    return 'Se mantuvieron';
  }
  if (/\b(bajaron|bajo|bajan|disminuyeron|disminuyo|redujeron|redujo|menor|mas bajo)\b/.test(key)) {
    return 'Bajaron';
  }
  if (/\b(mixto|depende|variable|rutas|ruta|naviera|navieras)\b/.test(key)) {
    return 'Mixto / depende de ruta';
  }

  return value.toString().trim();
};

export const hasMarketTrend = (value = '') => Boolean(normalizeMarketTrend(value));
